const TitleDisplay = {
    Chinese: "chinese",
    Original: "original",
    Romanized: "romanized"
}

export default TitleDisplay;
